export const JP_PAGE_DRAFT_LIBRARY = 'Draft Job Profiles Library';
export const JP_PAGE_PUBLISHED_LIBRARY = 'Published Job Profiles Library';
export const JP_PAGE_TEMPLATES_LIBRARY = 'Job Profile Templates Library';

export const getJpLibPageFromRoute = (routeName) => {
  if (routeName === 'published-job-profiles') return JP_PAGE_PUBLISHED_LIBRARY;
  if (routeName === 'draft-job-profiles') return JP_PAGE_DRAFT_LIBRARY;
  if (routeName === 'job-profile-templates') return JP_PAGE_TEMPLATES_LIBRARY;

  return null;
};

export const isJpLibraryRoute = (routeName) => (
  routeName === 'published-job-profiles'
  || routeName === 'draft-job-profiles'
  || routeName === 'job-profile-templates'
);

export const getJpLibProfileType = ({ isHris = false, isTemplate = false } = {}) => {
  if (isHris) return 'HRIS';
  if (isTemplate) return 'Template';

  return 'Draft';
};

export const getJpEditorProfileType = ({ isHris, isTemplate }) => {
  if (isHris) return 'job_profile_hris';
  if (isTemplate) return 'job_profile_template';

  return 'job_profile';
};
